// A panel that slides up from the bottom on a phone (thumb zone) and sits in the middle on a laptop.
import { Dialog } from "radix-ui";
import { X } from "lucide-react";
import type { ReactNode } from "react";
import { cn } from "./ui";

export function Sheet({
  open,
  onOpenChange,
  title,
  description,
  children,
  className,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-30 bg-ink/40" />
        <Dialog.Content
          className={cn(
            "fixed inset-x-0 bottom-0 z-40 max-h-[90dvh] overflow-y-auto rounded-t-3xl bg-surface px-4 pt-4 pb-[max(1.25rem,env(safe-area-inset-bottom))] text-ink shadow-xl",
            "sm:inset-x-auto sm:bottom-auto sm:top-1/2 sm:left-1/2 sm:w-[32rem] sm:-translate-x-1/2 sm:-translate-y-1/2 sm:rounded-3xl",
            className,
          )}
        >
          <div className="mb-3 flex items-start justify-between gap-3">
            <Dialog.Title className="text-xl font-bold">{title}</Dialog.Title>
            <Dialog.Close
              className="-mt-1 -mr-2 flex size-11 shrink-0 items-center justify-center rounded-xl text-ink-soft"
              aria-label="Sluiten"
            >
              <X aria-hidden className="size-6" />
            </Dialog.Close>
          </div>
          {description ? (
            <Dialog.Description className="mb-3 text-ink-soft">{description}</Dialog.Description>
          ) : (
            <Dialog.Description className="sr-only">{title}</Dialog.Description>
          )}
          {children}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
